

























































































































































































































import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../../store/modules/MembershipState'
import axios from 'axios'
import { DownloadHistoryInfo } from '../../../modules/class/Downloads'
import DownloadLink from '../DownloadLink.vue'
import ErrorFormResponse from '../../../modules/class/ErrorFormResponse'
import Pagenation from '../../../modules/util/Pagenation'
import PathUtil from '../../../modules/util/PathUtil'
import UidCookie from '../../../modules/util/UidSetCookie'
import { SapLoginInfo, ssoLogin } from '../../../modules/util/SapUtil'

@Component({
  components: {
    DownloadLink
  }
})
export default class MypageDownloadHistory extends Vue {
  private readonly vueid = 'vue_mypage_download_history'

  // --------------------------------------------------------------------------------------------------------------------
  // Props
  get showpage(): boolean {
    return membershipState.isLogin && this.showlists.length > 0
  }

  // --------------------------------------------------------------------------------------------------------------------
  // data
  private downloadhistory: DownloadHistoryInfo = new DownloadHistoryInfo({})
  private showlists: DownloadHistoryInfo[] = []

  private resultError: ErrorFormResponse = {}
  private haserror = false

  // pagination
  private pagenation: Pagenation = new Pagenation()
  private currentPage = 0 // 現在のページ番号
  private pageRange = 5 // ページネーションに表示するページ数の上限
  private size = 10 // 1ページに表示するアイテムの上限
  private showPrev = false
  private showNext = false

  // Showing
  private navhead = 1
  private navend = 10

  private uidcookie = new UidCookie()

  // -------------------------------------------------------------------------------------------------------------------
  // hocks
  private mounted() {
    if (document.getElementById(this.vueid) !== null) {
      if (membershipState.isLogin) {
        // ダウンロード履歴一覧取得
        // 画面表示前にインスタンスを生成してしまうため、createdでは取得できない
        this.initdownload()
      } else {
        this.clearelement()
      }
    }
  }

  // -------------------------------------------------------------------------------------------------------------------
  // methods

  private clearelement() {
    this.downloadhistory = new DownloadHistoryInfo({})
    this.showlists = []
    this.resultError = {}
    this.pagenation = new Pagenation()
  }

  /**
   * init get download lsit
   */
  private async initdownload() {
    // DL制御用のFlgをOFF
    membershipState.addAccessUrl('')
    membershipState.addDownloadStatus(0)
    this.verifyLoginDownload()
  }

  /**
   * ダウンロード履歴取得verifyLogin
   */
  private verifyLoginDownload() {
    window.gigya.accounts.verifyLogin({
      include: 'preferences',
      callback: this.verifyLoginDownloadResponse
    })
  }

  /**
   * ダウンロード履歴取得コールバック
   */
  private async verifyLoginDownloadResponse(response: {
    errorCode: number
    UID: string
    UIDSignature: string
    signatureTimestamp: string
  }) {
    if (response.errorCode === 0) {
      const info: SapLoginInfo = {
        UID: response.UID,
        UIDSignature: response.UIDSignature,
        signatureTimestamp: response.signatureTimestamp
      }

      // Cookieに３点セットをセット
      this.uidcookie.setUid(info)

      // 全件数取得
      try {
        const res = await axios.post(
          PathUtil.makePath('/member/api/download_history')
        )
        if (res.data.total > 0) {
          for (const item of res.data.history) {
            this.showlists.push(new DownloadHistoryInfo(item))
          }
        } else {
          // nothing download history
          this.showlists = []
        }
      } catch (err) {
        if (axios.isAxiosError(err) && err.response?.status === 403) {
          ssoLogin(window.location.href, 'gigya-login-screen')
        }
      }
    } else {
      // ログインしていないときはCookieを消す
      this.uidcookie.unSetUid()
    }
  }

  /**
   * download url clickにて発生したエラーを初期化する
   */
  private clearError() {
    this.resultError = {}
    this.haserror = false
  }

  /**
   * download url clickにて発生したエラーをDownladLinkコンポーネントから受け取る
   */
  private setError(error: ErrorFormResponse) {
    this.resultError = error
    this.haserror = true
  }

  /**
   * ドキュメントタイトルクリック
   */
  private documentTitleClick(index: number) {
    // クリックした要素を取得
    const clickElement: Element | null =
      document.getElementsByClassName('historytitle').item(index) !== null
        ? document.getElementsByClassName('historytitle').item(index)
        : null
    if (clickElement !== null) {
      // 親要素を取得
      const parentElement: HTMLElement | null =
        clickElement.parentElement !== null ? clickElement.parentElement : null
      if (parentElement !== null) {
        // 次の兄弟要素を取得
        const nextElementSibling: Element | null =
          parentElement.nextElementSibling !== null
            ? parentElement.nextElementSibling
            : null
        if (nextElementSibling !== null) {
          // ダウンロードリンク要素を取得
          const downloadLinkElement: HTMLElement | null =
            nextElementSibling.getElementsByTagName('a').item(0) !== null
              ? nextElementSibling.getElementsByTagName('a').item(0)
              : null
          if (downloadLinkElement !== null) {
            // ダウンロードリンクのクリックと同様の処理を行う
            downloadLinkElement.click()
          }
        }
      }
    }
  }

  /**
   * 以下、ページネーション用、computed, method
   * ダウンロード一覧はshowlistsを扱う
   */

  // ページ数を取得する
  get pages(): number {
    return Math.ceil(this.showlists.length / this.size)
  }

  // 最大件数を取得する
  get maxcount(): number {
    return this.showlists.length
  }

  // ページネーションで表示するページ番号の範囲を取得する
  get displayPageRange(): number[] {
    const d = this.pagenation.displayPageRange(
      this.pageRange,
      this.pages,
      this.currentPage,
      this.showPrev,
      this.showNext
    )
    this.showPrev = d.showPrev
    this.showNext = d.showNext
    return d.indexes
  }

  // 表示件数変更
  private changerows() {
    // 途中ページで表示件数を変えると先頭に戻る（現在ページを維持できないため）
    this.currentPage = 0
  }

  // ページネーションに合わせてデータ取得変更
  get displayItems(): DownloadHistoryInfo[] {
    const head = this.currentPage * this.size
    // Showing設定
    const navs = this.pagenation.setShowing(
      head,
      this.maxcount,
      this.size,
      this.navhead,
      this.navend
    )
    this.navhead = navs.navHead
    this.navend = navs.navEnd
    return this.showlists.slice(head, head + this.size)
  }

  private selectHandler() {
    // 何か必要な処理があれば
  }

  // 未使用
  private first() {
    this.currentPage = 0
    this.selectHandler()
  }

  // 未使用
  private last() {
    this.currentPage = this.pages - 1
    this.selectHandler()
  }

  private prev() {
    this.currentPage = this.pagenation.prev(this.currentPage)
  }

  private next() {
    this.currentPage = this.pagenation.next(this.currentPage, this.pages)
  }

  private pageSelect(index: number) {
    this.currentPage = this.pagenation.pageSelect(this.currentPage, index)
  }
}
